import lodash from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Paper } from '@material-ui/core';
import {
    Input, Button, Pagination, Card, Col, Row, Spin, Tooltip,
} from 'antd';
import Moment from 'react-moment';
import { get } from '../../../../../shared/helpers';
import { addNoteRequest } from '../../redux/actions/add_note.actions';

const { TextArea } = Input;

class CustomerNotes extends Component {
    state = {
        note: '',
        start: 0,
        end: 10,
        pageSize: 10,
        loading: false,
        flipped: false,
    };

    handleChange = (event) => this.setState({ note: event.target.value });

    addNote = () => {
        this.props.dispatch(addNoteRequest(this.props.lead_id, this.state.note));
        this.setState({ note: '' });
    };

    delNote = (noteId) => {
        const { lead_id } = this.props;

        this.props.dispatch({ type: 'DEL_LEAD_NOTE', payload: { leadId: lead_id, noteId } });
    }

    handleNotesQuantity = (quantity) => {
        this.setState({ start: this.state.pageSize * quantity - 10, end: this.state.pageSize * quantity });
    };

    render() {
        let { notes, allowedDelNotes } = this.props;
        const {
            note, start, end, loading,
        } = this.state;
        notes = notes.filter((item) => !item.deleted_date).reverse();

        return (
            <Spin spinning={this.props.loading} tip="Notes updating ...">
                <Paper style={{ padding: 24 }}>
                    <Row>
                        <Col span={24}>
                            <h3>Customer Notes</h3>
                            <TextArea placeholder="Add new note" value={note} onChange={this.handleChange} />
                            <Button
                                type="primary"
                                style={{ margin: '10px 0' }}
                                disabled={!loading ? !note : note}
                                onClick={this.addNote}
                            >
                                Add Note
                            </Button>
                            <ul className="notes_position">
                                {
                                    !notes.length
                                        ? <div style={{ textAlign: 'center', fontStyle: 'italic' }}>No Notes</div>
                                        : notes.slice(start, end).map((note) => (
                                            <li key={note._id}>
                                                <strong>
                                                    <Moment format="D MMM YYYY @ HH:mm">{note.created_date}</Moment>
                                                &nbsp;-&nbsp;
                                                    <span>
                                                        {get(note.note_by, 'person.first_name')}
                                                        {' '}
                                                        {get(note.note_by, 'person.last_name')}
                                                    </span>
                                                    {
                                                        allowedDelNotes && (
                                                            <Tooltip title="Delete note">
                                                                <span
                                                                    className="fa fa-trash"
                                                                    style={{
                                                                        color: 'rgb(253 7 7 / 70%)',
                                                                        float: 'right',
                                                                        cursor: 'pointer',
                                                                        paddingTop: '5px',
                                                                        fontSize: '10px',
                                                                    }}
                                                                    onClick={() => this.delNote(note._id)}
                                                                />
                                                            </Tooltip>
                                                        )
                                                    }
                                                </strong>
                                                <p>{note.note}</p>
                                            </li>
                                        ))
                                }
                            </ul>
                        </Col>
                    </Row>
                    <hr />
                    {/* parse="YYYY.MM.DD HH:mm" */}
                    <Pagination
                        size="small"
                        defaultCurrent={1}
                        total={notes.length}
                        defaultPageSize={10}
                        onChange={this.handleNotesQuantity}
                        style={{ textAlign: 'center' }}
                    />
                </Paper>
            </Spin>
        );
    }
}

const mapStateToProps = (state) => {
    const { notes, loading } = state.Leads.Lead_profile.Lead_notes;
    const lead_id = state.Leads.Lead_profile.Lead_general.root_id;
    const allowedDelNotes = lodash.get(state, 'App.Permissions.allowedUrls.method://Leads/deleteLeadNote');
    return {
        notes, loading, lead_id, allowedDelNotes,
    };
};

export default connect(mapStateToProps, null)(CustomerNotes);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/CustomerNotes.js